import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {OrganizationData, RegionData} from '../../../shared/types/nso-data-portal/entity-data';
import {FileRestService} from '../../../shared/services/common/file/file-rest.service';
import {FileUtilsService} from '../../../shared/services/common/file/file-utils.service';
import {SearchEntityLevels} from '../../../shared/types/nso-data-portal/search-entity-levels';
import {PersonRestService} from '../../../shared/services/person/person-rest.service';
import {SecurityService} from '../../../shared/services/security/security.service';

@Component({
  selector: 'wsd-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.css']
})
export class SidePanelComponent implements OnChanges {

  @Input()
  entity: OrganizationData & RegionData;

  @Input()
  entityLevel: SearchEntityLevels;

  @Output()
  public onContactUpdate = new EventEmitter<void>();

  searchEntityLevels = SearchEntityLevels;

  showParent: boolean = true;

  imageSrc: any;

  constructor(private fileRestService: FileRestService,
              private fileUtilsService: FileUtilsService,
              private securityService: SecurityService,
              private personService: PersonRestService) {
  }

  ngOnChanges(event) {
    this.imageSrc = null;
    if (event.entity) {
      if (event.entity.currentValue.profileImageId) {
        this.loadImage(this.entity.profileImageId);
      }
    }
    this.securityService.getLoggedUser().subscribe(user => {
      this.securityService.hasPermission('NDP_FEDERATION_READ').subscribe(hasFederationRead => {
        if (user.consultantId) {
          this.personService.getPersonFromAllPersons(user.consultantId).subscribe(person => {
            if (person.organization) {
              this.showParent = (person.organization.id === this.entity.parentOrganizationId) || hasFederationRead;
            }
          });
        }
      });
    });
  }

  private loadImage(imgId: number) {
    this.imageSrc = null;
    if (!imgId) {
      this.imageSrc = null;
      return;
    }
    this.fileRestService.getImage(imgId.toString()).subscribe(
      (data: any) => {
        this.imageSrc = this.fileUtilsService.getImage(data.content);
      }
    );
  }

  get address() {
    if (this.entity.supportCenter) {
      return this.entity.supportCenter.address;
    } else {
      return this.entity.address;
    }
  }

  get contactsUpdatedInYear(): boolean {
    if (this.entityLevel === SearchEntityLevels.REGION || this.entityLevel === SearchEntityLevels.WORLD) {
      return true;
    }
    return this.entity.contactsUpdatedInYear;
  }
}
